"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProviderConfigSchemas = exports.getFullConfigSchema = exports.schemaWithOptions = exports.schemaWithDefault = exports.booleanSchema = exports.numberSchema = exports.strSchema = void 0;
exports.strSchema = {
    type: 'string',
};
exports.numberSchema = {
    type: 'number',
};
exports.booleanSchema = {
    type: 'boolean',
};
function schemaWithDefault(defaultVal) {
    var typeVal = typeof defaultVal;
    var retSchema = {
        type: typeVal,
        default: defaultVal
    };
    if (Array.isArray(defaultVal)) {
        var itemsTypeVal = typeof defaultVal[0];
        retSchema['items'] = { type: itemsTypeVal };
        retSchema.type = 'array';
        return retSchema;
    }
    return retSchema;
}
exports.schemaWithDefault = schemaWithDefault;
function schemaWithOptions(opts) {
    if (!opts.length) {
        throw new Error('Must provide at least one option');
    }
    if (opts.length === 1) {
        throw new Error('If only one valid value, use a default value instead');
    }
    return {
        type: typeof opts[0],
        enum: opts
    };
}
exports.schemaWithOptions = schemaWithOptions;
function getFullConfigSchema(propsSchema, configKeyName) {
    var schema = {
        type: 'object',
        required: [
            'extensionImplClassName',
            configKeyName,
        ],
        properties: {
            extensionImplClassName: exports.strSchema,
        },
        additionalProperties: false
    };
    schema.properties[configKeyName] = propsSchema;
    return schema;
}
exports.getFullConfigSchema = getFullConfigSchema;
var algorithmsSchema = {
    type: 'object',
    required: [
        'kex',
        'cipher'
    ],
    properties: {
        kex: schemaWithDefault([
            "ecdh-sha2-nistp256",
            "ecdh-sha2-nistp384",
            "ecdh-sha2-nistp521",
            "diffie-hellman-group14-sha1",
            "diffie-hellman-group-exchange-sha256",
            "diffie-hellman-group-exchange-sha1",
            "diffie-hellman-group1-sha1"
        ]),
        cipher: schemaWithDefault([
            "aes128-ctr",
            "aes192-ctr",
            "aes256-ctr",
            "aes128-gcm@openssh.com",
            "aes128-gcm",
            "aes256-gcm",
            "aes256-gcm@openssh.com",
            "aes256-cbc",
            "aes192-cbc",
            "aes128-cbc",
            "3des-cbc"
        ])
    },
    additionalProperties: false
};
var sshSchema = {
    type: 'object',
    required: [
        'host',
        'liveHost',
        'port',
        'username',
        'downloadTimeout',
        'uploadTimeout',
        'algorithms',
    ],
    properties: {
        host: exports.strSchema,
        liveHost: exports.strSchema,
        port: exports.numberSchema,
        username: exports.strSchema,
        password: exports.strSchema,
        privateKey: exports.strSchema,
        downloadTimeout: exports.numberSchema,
        uploadTimeout: exports.numberSchema,
        algorithms: algorithmsSchema,
    },
    additionalProperties: false
};
var sftpFileTransferSchema = {
    title: 'SftpFileTransferConfig',
    type: 'object',
    required: [
        'ssh',
        'achUploadPath',
        'achDownloadPath',
        'encoding',
        'delete',
        'liveTestMode',
        'runModes'
    ],
    properties: {
        ssh: sshSchema,
        achUploadPath: exports.strSchema,
        achDownloadPath: exports.strSchema,
        encoding: exports.strSchema,
        delete: exports.booleanSchema,
        liveTestMode: exports.booleanSchema,
        runModes: exports.strSchema,
    },
    additionalProperties: false
};
var s3FileTransferSchema = {
    title: 'S3FileTransferConfig',
    type: 'object',
    required: [
        'bucket',
        'endpoint',
        'region',
        'encoding',
        'prefix',
    ],
    properties: {
        bucket: exports.strSchema,
        endpoint: exports.strSchema,
        region: exports.strSchema,
        prefix: exports.strSchema,
        encoding: exports.strSchema,
        delete: exports.booleanSchema,
        liveTestMode: exports.booleanSchema,
        runModes: exports.strSchema,
    },
    additionalProperties: false
};
var payloadSchema = {
    type: 'object',
    required: [
        'orbitalConnectionUsername',
        'orbitalConnectionPassword',
        'bin',
        'terminalID',
        'industryType',
        'mitMsgType',
        'mitStoredCredentialInd',
    ],
    properties: {
        orbitalConnectionUsername: exports.strSchema,
        orbitalConnectionPassword: exports.strSchema,
        bin: exports.strSchema,
        terminalID: exports.strSchema,
        industryType: exports.strSchema,
        mitMsgType: exports.strSchema,
        mitStoredCredentialInd: exports.strSchema,
    },
    additionalProperties: false
};
var merchantIdsSchema = {
    type: 'object',
    required: [
        'Default',
        'HavenDI',
    ],
    properties: {
        Default: exports.strSchema,
        HavenDI: exports.strSchema,
    },
    additionalProperties: false
};
var ConfigProperties = /** @class */ (function () {
    function ConfigProperties() {
    }
    ConfigProperties.ChaseAchPaymentProviderProps = {
        type: 'object',
        required: [
            'ackFileNameRegex',
            'journalEntryFileNameRegex',
            'achReturnFileNameRegex',
            'localPath',
            'timezone',
            'nachaOdfi',
            'nachaDestinationId',
            'nachaDestinationName',
            'nachaOriginId',
            'fileTransferImplClassName',
            'fileTransfer'
        ],
        properties: {
            ackFileNameRegex: exports.strSchema,
            journalEntryFileNameRegex: exports.strSchema,
            achReturnFileNameRegex: exports.strSchema,
            localPath: exports.strSchema,
            timezone: exports.strSchema,
            nachaOdfi: exports.strSchema,
            nachaDestinationId: exports.strSchema,
            nachaDestinationName: exports.strSchema,
            nachaOriginId: exports.strSchema,
            fileTransferImplClassName: exports.strSchema,
            fileTransfer: sftpFileTransferSchema
        },
        additionalProperties: false
    };
    ConfigProperties.ChaseCreditCardPaymentProviderProps = {
        type: 'object',
        required: [
            'wsdl',
            'failoverWsdl',
            'version',
            'payload',
            'merchantIds'
        ],
        properties: {
            wsdl: exports.strSchema,
            failoverWsdl: exports.strSchema,
            version: exports.strSchema,
            payload: payloadSchema,
            merchantIds: merchantIdsSchema,
        },
        additionalProperties: false
    };
    ConfigProperties.MMCheckPaymentProviderProps = {
        type: 'object',
        required: [
            'IBFurl',
            'IBFendpoint',
            'ZendeskEndpoint',
            'IBFusername',
            'IBFpassword',
            'IBFschemaId',
            'ZendeskSchemaId',
            'IBFcontentType',
            'IBFnamespaceIdentifier',
            'ZendeskNamespaceIdentifier',
        ],
        properties: {
            IBFurl: exports.strSchema,
            IBFendpoint: exports.strSchema,
            ZendeskEndpoint: exports.strSchema,
            IBFusername: exports.strSchema,
            IBFpassword: exports.strSchema,
            IBFschemaId: exports.strSchema,
            ZendeskSchemaId: exports.strSchema,
            IBFcontentType: exports.strSchema,
            IBFnamespaceIdentifier: exports.strSchema,
            ZendeskNamespaceIdentifier: exports.strSchema,
        },
        additionalProperties: false
    };
    ConfigProperties.HTAThirdPartyPaymentProviderProps = {
        type: 'object',
        required: [
            'HTAurl',
            'chargeEndpoint',
            'refundEndpoint',
            'contentType',
        ],
        properties: {
            HTAurl: exports.strSchema,
            chargeEndpoint: exports.strSchema,
            refundEndpoint: exports.strSchema,
            contentType: exports.strSchema,
        },
        additionalProperties: false
    };
    ConfigProperties.EcabExternalBankPaymentProviderProps = {
        type: 'object',
        required: [
            'fileNameRegex',
            'localPath',
            'timezone',
            'fileTransferImplClassName',
            'fileTransfer'
        ],
        properties: {
            fileNameRegex: exports.strSchema,
            localPath: exports.strSchema,
            timezone: exports.strSchema,
            fileTransferImplClassName: exports.strSchema,
            fileTransfer: s3FileTransferSchema
        },
        additionalProperties: false
    };
    return ConfigProperties;
}());
var PaymentProviderConfigSchemas = /** @class */ (function () {
    function PaymentProviderConfigSchemas() {
    }
    PaymentProviderConfigSchemas.ChaseAchPaymentProvider = getFullConfigSchema(ConfigProperties.ChaseAchPaymentProviderProps, 'achConfig');
    PaymentProviderConfigSchemas.ChaseCreditCardPaymentProvider = getFullConfigSchema(ConfigProperties.ChaseCreditCardPaymentProviderProps, 'creditCardConfig');
    PaymentProviderConfigSchemas.MMCheckPaymentProvider = getFullConfigSchema(ConfigProperties.MMCheckPaymentProviderProps, 'checkConfig');
    PaymentProviderConfigSchemas.HTAThirdPartyPaymentProvider = getFullConfigSchema(ConfigProperties.HTAThirdPartyPaymentProviderProps, 'thirdPartyPaymentConfig');
    PaymentProviderConfigSchemas.EcabExternalBankPaymentProvider = getFullConfigSchema(ConfigProperties.EcabExternalBankPaymentProviderProps, 'bankConfig');
    return PaymentProviderConfigSchemas;
}());
exports.PaymentProviderConfigSchemas = PaymentProviderConfigSchemas;
